import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DELETE_TASKASSIGNMENT } from "./apiRoutes";

export interface DeleteTaskAssigenementResponse {
  message: string;
  success: boolean;
}

const deleteTaskAssigenemnt = async (id: string) => {
  const response = await axiosAuth.delete<DeleteTaskAssigenementResponse>(
    `${DELETE_TASKASSIGNMENT}${id}/`
  );
  return response.data;
};

export const useDeleteTaskAssignmentMutation = (
  options?: UseMutationOptions<
    DeleteTaskAssigenementResponse,
    Error,
    string
  >
) => {
  return useMutation({
    mutationFn: deleteTaskAssigenemnt,
    ...options,
  });
};
